import React from "react";
import {Col, DatePicker, Form, Input, Modal, Row, Select} from "antd";
import LoadingIndicator from "../LoadingIndicator";
import BrdgxCountrySelector from "../selector/BrdgxCountrySelector";
import OriginalIDTypeSelector from "../selector/OriginalIDTypeSelector";
import moment from "moment";
import BrdgxNationalitySelector from "../selector/BrdgxNationalitySelector";
import {
  createOrUpdateOriginator,
  getAddressFromPostalCode,
  getCountryList, getIndustryCode,
  getNationalityList,
  getOccupationCode,
  getSourceOfFundCode,
} from "../../api/api";
import {displayError, displayGenericError, displaySuccessMessageWithSeconds} from "../../common/notifications";
import SourceOfFundsSelector from "../selector/SourceOfFundsSelector";
import "./OriginatorModal.css";
import IndustrySelector from "../selector/IndustrySelector";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

const confirm = Modal.confirm;


class OriginatorModal extends React.Component {
  state = {
    isLoading: true,
    originator: this.props.originator,
    mode: this.props.mode,
    occupations:[],
    companyTypes:[],
    checkCommonFieldsFilled: {
      originatorType: true,
      sourceOfFunds: true,
    },
    checkCorporateRequiredFieldsFilled: {
      businessName: true,
      countryIncorporated: true,
      businessNumber: true,
      industry: true,
      dob:true
    },
    checkIndividualRequiredFieldsFilled: {
      firstName: true,
      lastName: true,
      idType: true,
      idNumber: true,
      nationality: true,
      dob:true,
      countryOfResidence: true,
    }
  };

  onOriginatorFieldChanged = (fieldName, newValue) => {
    let selectedOriginator = this.props.selectedOriginator;
    if(selectedOriginator) {
      selectedOriginator[fieldName]=newValue;
      this.props.updateSelectedOriginator(selectedOriginator);
    }else {
      this.setState({
        originator: Object.assign(this.state.originator, {[fieldName]: newValue}),
        checkCommonFieldsFilled: Object.assign(this.state.checkCommonFieldsFilled, {[fieldName]: true}),
        checkCorporateRequiredFieldsFilled: Object.assign(this.state.checkCorporateRequiredFieldsFilled, {[fieldName]: true}),
        checkIndividualRequiredFieldsFilled: Object.assign(this.state.checkIndividualRequiredFieldsFilled, {[fieldName]: true}),
      }, function () {
      });
    }
  }
  onOriginatorTextChange = (event) => {
    let inputName = event.target.name;
    let selectedOriginator = this.props.selectedOriginator;
    if (selectedOriginator) {
      selectedOriginator[inputName] = event.target.value;
      this.props.updateSelectedOriginator(selectedOriginator);
    } else {
      this.setState({
        originator: Object.assign(this.state.originator, {[inputName]: event.target.value}),
        checkCommonFieldsFilled: Object.assign(this.state.checkCommonFieldsFilled, {[inputName]: true}),
        checkCorporateRequiredFieldsFilled: Object.assign(this.state.checkCorporateRequiredFieldsFilled, {[inputName]: true}),
        checkIndividualRequiredFieldsFilled: Object.assign(this.state.checkIndividualRequiredFieldsFilled, {[inputName]: true}),
      }, function () {
      });
    }
  }
  componentDidMount() {

    getNationalityList()
        .then(response => {
          this.setState({
            nationalities: response
          });
        })
        .catch(error => {
          displayGenericError(error);
        });
    getCountryList()
        .then(response => {
          this.setState({
            countries: response
          });
        })
        .catch(error => {
          displayGenericError(error);
        });

    getOccupationCode().then(response => {
      this.setState({
        occupations: response
      });

    }).catch(error => {
      displayGenericError(error);
    });
    this.setState({
      originator: this.props.originator || {},
      isLoading: false
    });

    getSourceOfFundCode(localStorage.getItem("ACCESS_TOKEN")).then(response => {
      this.setState({
        sourceOfFunds: response
      });
    }).catch(error => {
      displayGenericError(error);
    });
  }
  onCancel = () => {
    if (this.props.mode === "new") {
      this.setState({
        originator: {}
      })
    }
    this.props.onCancel();
  };
  handleOk = () => {
    /*Start Client validation*/
    let { originator } = this.state;
    let selectedOriginator = this.props.selectedOriginator;
    if(selectedOriginator){
      originator = this.props.selectedOriginator;
    }

    var isAllFieldsTrue = true;

    /*Start Check Common fields filled*/
    let checkCommonFieldsFilled = this.state.checkCommonFieldsFilled;
    if ((originator.originatorType || '').trim().length === 0) {
      checkCommonFieldsFilled.originatorType = false;
    } else {
      checkCommonFieldsFilled.originatorType = true;
    }

    if ((originator.sourceOfFunds || '').trim().length === 0) {
      checkCommonFieldsFilled.sourceOfFunds = false;
    } else {
      checkCommonFieldsFilled.sourceOfFunds = true;
    }

    this.setState({
      checkCommonFieldsFilled: checkCommonFieldsFilled,
    })
    //Check all Common fields filled
    for (let field in this.state.checkCommonFieldsFilled) {
      if (!this.state.checkCommonFieldsFilled[field]) {
        isAllFieldsTrue = false;
      }
    }
    /*End Check Common fields filled*/


    /*Start Check Corporation Fields Filled*/
    if (originator.originatorType === 'CORPORATE') {
      let checkCorporateRequiredFieldsFilled = this.state.checkCorporateRequiredFieldsFilled;
      //Check Business Name
      if ((originator.businessName || '').trim().length === 0) {
        checkCorporateRequiredFieldsFilled.businessName = false;
      }else {
        checkCorporateRequiredFieldsFilled.businessName = true;
      }

      if ((originator.countryIncorporated || '').trim().length === 0) {
        checkCorporateRequiredFieldsFilled.countryIncorporated = false;
      }else {
        checkCorporateRequiredFieldsFilled.countryIncorporated = true;
      }

      if ((originator.businessNumber || '').trim().length === 0) {
        checkCorporateRequiredFieldsFilled.businessNumber = false;
      }else {
        checkCorporateRequiredFieldsFilled.businessNumber = true;
      }

      if(originator.dob) {
        checkCorporateRequiredFieldsFilled.dob= true;
      } else {
        checkCorporateRequiredFieldsFilled.dob= false;
      }

      if(originator.industry) {
        checkCorporateRequiredFieldsFilled.industry= true;
      } else {
        checkCorporateRequiredFieldsFilled.industry= false;
      }

      this.setState({
        checkCorporateRequiredFieldsFilled: checkCorporateRequiredFieldsFilled,
      })
      //Check all Corporate fields filled
      for (let field in this.state.checkCorporateRequiredFieldsFilled){
        if (!this.state.checkCorporateRequiredFieldsFilled[field]){
          isAllFieldsTrue = false;
        }
      }
    }

    /*Start Check Individual Fields Filled*/
    if (originator.originatorType === 'INDIVIDUAL') {
      let checkIndividualRequiredFieldsFilled = this.state.checkIndividualRequiredFieldsFilled;
      if ((originator.firstName || '').trim().length === 0) {
        checkIndividualRequiredFieldsFilled.firstName = false;
      }else {
        checkIndividualRequiredFieldsFilled.firstName = true;
      }

      if ((originator.lastName || '').trim().length === 0) {
        checkIndividualRequiredFieldsFilled.lastName = false;
      }else {
        checkIndividualRequiredFieldsFilled.lastName = true;
      }

      if ((originator.idType || '').trim().length === 0) {
        checkIndividualRequiredFieldsFilled.idType = false;
      }else {
        checkIndividualRequiredFieldsFilled.idType = true;
      }

      if ((originator.idNumber || '').trim().length === 0) {
        checkIndividualRequiredFieldsFilled.idNumber = false;
      }else {
        checkIndividualRequiredFieldsFilled.idNumber = true;
      }

      if ((originator.countryOfResidence || '').trim().length === 0) {
        checkIndividualRequiredFieldsFilled.countryOfResidence = false;
      }else {
        checkIndividualRequiredFieldsFilled.countryOfResidence = true;
      }

      if ((originator.nationality || '').trim().length === 0) {
        checkIndividualRequiredFieldsFilled.nationality = false;
      }else {
        checkIndividualRequiredFieldsFilled.nationality = true;
      }

      if ((!moment(originator.dob, "YYYY-MM-DD").isValid())
          || (moment().diff(moment(originator.dob, "YYYY-MM-DD"),'years') < 18)) {
        checkIndividualRequiredFieldsFilled.dob = false;
      }else {
        checkIndividualRequiredFieldsFilled.dob = true;
      }

      this.setState({
        checkIndividualRequiredFieldsFilled: checkIndividualRequiredFieldsFilled,
      })

      //Check All required field are filled
      for (let field in this.state.checkIndividualRequiredFieldsFilled) {
        if (!this.state.checkIndividualRequiredFieldsFilled[field]){
          isAllFieldsTrue = false;
        }
      }
    }
    /*End Check Individual Fields Filled*/

    if (!isAllFieldsTrue) {
      return;
    }

    const intl = this.props.useIntl;

    /*Create or Update Customer*/
    confirm({
      title: <p>Are you sure you want to save current Customer?</p>,
      onOk: () => {
        this.setState({
          isLoading: true
        });
        createOrUpdateOriginator(this.props.customerId, originator)
            .then(response => {
              if (this.props.mode === "new") {
                this.setState({
                  isLoading: false,
                  originator: {}
                });
              }else{
                this.setState({
                  isLoading: false,
                  originator: {}
                });
              }

              this.props.onCompleted(response);

              displaySuccessMessageWithSeconds(intl.formatMessage({id: "app.common.successfully"}), 2)
            })
            .catch(error => {
              this.setState({
                isLoading: false
              });
              displayGenericError(error);
            });
      }
    });

  };
  onNoHitChange = (event) => {
    const target = event.target;
    if (target.checked) {
      this.setState({
        originator: {
          ...this.state.originator,
          noHit: target.checked,
          pep: false,
          sanction: false,
          adverseNews: false
        }
      }, function () {
      });
    } else {
      this.setState({
        originator: {
          ...this.state.originator,
          noHit: target.checked
        }
      }, function () {
      });
    }
  }

  onOriginatorComplianceChanged = (event, field) => {
    if (["pep", "sanction", "adverseNews"].includes(field)) {
      this.setState({
        originator: {
          ...this.state.originator,
          noHit: false,
          [field]: event.target.checked
        }
      }, function () {
      });
      return;
    }
    this.setState({
      originator: {
        ...this.state.originator,
        [field]: event.target.checked
      },
    }, function () {
    });
  };

  onFullOnboardingChecked = (event) => {
    this.setState({
      originator: Object.assign(this.state.originator,{[event.target.name]:event.target.checked})
    })
  }
  findAddressFromPostalCode = () =>{
    const intl = this.props.useIntl;
    getAddressFromPostalCode(this.state.originator.postalCode).then(response=>{
      let found = response.found;
      if(found ===0){
        displayError(intl.formatMessage({id: "app.message.originatormodal.noaddressfound"}))
      }else{
        let address1;
        if(response.results[0].blk_NO !== ''){
          address1 = response.results[0].blk_NO + ", "+ response.results[0].road_NAME;
        }else{
          address1 = response.results[0].road_NAME;
        }
        this.setState({
          details: Object.assign(this.state.originator, { ['addressLine1']: address1 ,
            ['addressLine2']:response.results[0].building, ['cityState']:'SINGAPORE' })
        });
      }
    }).catch(error => {
      displayGenericError(error);
    });
  }

  changeBusinessNature = value => {
    let selectedOriginator = this.props.selectedOriginator;
    if(selectedOriginator) {
      selectedOriginator.industry = value;
      this.props.updateSelectedOriginator(selectedOriginator);
    } else {
      let originator = this.state.originator;
      originator.industry = value;
      this.setState({
        originator: originator
      })
    }
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //   if (this.props.visible == false && prevProps.visible == true) {
  //     this.props.updateSelectedOriginator(null);
  //   }
  // }

  render() {
    const intl = this.props.useIntl;
    let { mode, originator, checkCommonFieldsFilled, checkCorporateRequiredFieldsFilled } = this.state;
    let selectedOriginator = this.props.selectedOriginator;
    if(selectedOriginator) {
      originator = selectedOriginator;
    } else {
      originator:{}
    }
    let sizeCol = 12;
    if(selectedOriginator) {
      sizeCol = 8;
    }

    return (
        <Modal
            title={
              this.props.mode === "new" ? intl.formatMessage({id: "app.modal.originatormodal.addnewsender"}) : intl.formatMessage({id: "app.modal.originatormodal.editsender"})
            }
            visible={this.props.visible}
            onOk={this.handleOk}
            onCancel={this.onCancel}
            okButtonProps={{ disabled: this.props.disabled }}
            className="originatorModal modal--wide"
            maskClosable={false}
            destroyOnClose={true}>
          {this.state.isLoading && <LoadingIndicator />}
          {!this.state.isLoading && (
              <div>
                <Row gutter={16}>
                  <Col className="gutter-row" md={sizeCol} sm={6}>
                    <Form.Item
                        label={intl.formatMessage({id: "app.modal.originatormodal.sendertype"})}
                        required="true"
                        validateStatus={checkCommonFieldsFilled.originatorType ? "success" : "error"}
                        help={checkCommonFieldsFilled.originatorType ? '' : intl.formatMessage({id: "app.message.originatormodal.sendertype"})}
                    >
                      <Select name="originatorType"
                              disabled={this.props.selectedOriginator ? true : false}
                              value={ originator.originatorType}
                              style={{ width: '100%' }}
                              onChange={newValue => this.onOriginatorFieldChanged('originatorType', newValue)}>
                        <Select.Option value="CORPORATE">CORPORATE</Select.Option>
                        <Select.Option value="INDIVIDUAL">INDIVIDUAL</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col className="gutter-row" md={sizeCol} sm={6}>
                    <Form.Item
                        label={intl.formatMessage({id: "app.modal.originatormodal.sourceoffunds"})}
                        validateStatus={checkCommonFieldsFilled.sourceOfFunds ? "success" : "error"}
                        help={checkCommonFieldsFilled.sourceOfFunds ? '' : intl.formatMessage({id: "app.message.originatormodal.sourceoffunds"})}
                    >
                      <SourceOfFundsSelector
                          disabled = {this.props.disabled}
                          sourceOfFunds = {this.state.sourceOfFunds}
                          placeholder={intl.formatMessage({id: "app.modal.originatormodal.selectsourceoffunds"})}
                          value={originator.sourceOfFunds}
                          onChange={newValue =>
                              this.onOriginatorFieldChanged("sourceOfFunds", newValue)
                          }
                      />
                    </Form.Item>
                  </Col>
                  {selectedOriginator && <Col className="gutter-row" md={sizeCol} sm={6}>
                    <Form.Item label={intl.formatMessage({id: "app.modal.originatormodal.referencenumber"})}>
                      <Input name='referenceNumber'
                             value={originator.referenceNumber ? originator.referenceNumber : ''}
                             onChange={this.onOriginatorTextChange}
                             disabled
                      />
                    </Form.Item>
                  </Col>
                  }
                </Row>
                { originator.originatorType === 'INDIVIDUAL' && (
                    <div>
                      <Row gutter={16}>
                        <Col className="gutter-row" md={12} sm={6}>
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.firstname"})}
                              required="true"
                              validateStatus={this.state.checkIndividualRequiredFieldsFilled.firstName ? "success" : "error"}
                              help={this.state.checkIndividualRequiredFieldsFilled.firstName ? '' : intl.formatMessage({id: "app.message.originatormodal.firstname"})}
                          >
                            <Input name="firstName"
                                   disabled={this.props.disabled}
                                   value={originator.firstName}
                                   onChange={this.onOriginatorTextChange}
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={12} sm={6}> 
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.lastname"})}
                              required="true"
                              validateStatus={this.state.checkIndividualRequiredFieldsFilled.lastName ? "success" : "error"}
                              help={this.state.checkIndividualRequiredFieldsFilled.lastName ? '' : intl.formatMessage({id: "app.message.originatormodal.lastname"})}
                          >
                            <Input name="lastName"
                                   disabled={this.props.disabled}
                                   value={originator.lastName}
                                   onChange={this.onOriginatorTextChange}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col className="gutter-row" md={12} sm={6}> 
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.idtype"})}
                              required="true"
                              validateStatus={this.state.checkIndividualRequiredFieldsFilled.idType ? "success" : "error"}
                              help={this.state.checkIndividualRequiredFieldsFilled.idType ? '' : intl.formatMessage({id: "app.message.originatormodal.idtype"})}
                          >
                            <OriginalIDTypeSelector
                                disabled={this.props.disabled}
                                placeholder='Id type'
                                value={originator.idType}
                                idTypes={this.props.idTypes}
                                onChange={newValue =>
                                    this.onOriginatorFieldChanged("idType", newValue)
                                }/>
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={12} sm={6}> 
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.idnumber"})}
                              required="true"
                              validateStatus={this.state.checkIndividualRequiredFieldsFilled.idNumber ? "success" : "error"}
                              help={this.state.checkIndividualRequiredFieldsFilled.idNumber ? '' : intl.formatMessage({id: "app.message.originatormodal.idnumber"})}
                          >
                            <Input name="idNumber"
                                   disabled={this.props.disabled}
                                   value={originator.idNumber}
                                   onChange={this.onOriginatorTextChange}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col className="gutter-row" md={8}>
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.residencecountry"})}
                              required="true"
                              validateStatus={this.state.checkIndividualRequiredFieldsFilled.countryOfResidence ? "success" : "error"}
                              help={this.state.checkIndividualRequiredFieldsFilled.countryOfResidence ? '' : intl.formatMessage({id: "app.message.originatormodal.residencecountry"})}
                          >
                            <BrdgxCountrySelector
                                disabled={this.props.disabled}
                                size={"large"}
                                style={{width:'100%'}}
                                placeholder={intl.formatMessage({id: "app.modal.originatormodal.selectcountry"})}
                                required="true"
                                value={originator.countryOfResidence ? originator.countryOfResidence : ''}
                                countries={this.state.countries}
                                onChange={newValue =>
                                    this.onOriginatorFieldChanged("countryOfResidence", newValue)
                                }
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={8}>
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.nationality"})}
                              validateStatus={this.state.checkIndividualRequiredFieldsFilled.nationality ? "success" : "error"}
                              help={this.state.checkIndividualRequiredFieldsFilled.nationality ? '' : intl.formatMessage({id: "app.message.originatormodal.nationality"})}
                          >
                            <BrdgxNationalitySelector
                                disabled={this.props.disabled}
                                placeholder={intl.formatMessage({id: "app.modal.originatormodal.selectnationality"})}
                                required="true"
                                size={"large"}
                                style={{width:'100%'}}
                                value={originator.nationality ? originator.nationality : ''}
                                nationalities={this.state.nationalities}
                                onChange={newValue =>
                                    this.onOriginatorFieldChanged("nationality", newValue)
                                }
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={8}>
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.dateofbirth"})}
                              validateStatus={this.state.checkIndividualRequiredFieldsFilled.dob ? "success" : "error"}
                              help={this.state.checkIndividualRequiredFieldsFilled.dob
                                  ? ''
                                  : !moment(originator.dob, "YYYY-MM-DD").isValid()
                                      ? intl.formatMessage({id: "app.message.originatormodal.dateofbirth"})
                                      : intl.formatMessage({id: "app.message.originatormodal.ageover18"})}
                          >
                            <DatePicker
                                // format={"YYYY/MM/DD"}
                                placeholder="YYYY-MM-DD"
                                style={{width: '100%'}}
                                size={"large"}
                                value={
                                  originator.dob
                                      ? moment(originator.dob)
                                      : null
                                }
                                disabled={this.props.disabled}
                                onChange={(newValue, newValueStr) =>
                                    this.onOriginatorFieldChanged("dob", newValueStr)
                                }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col md={6}>
                          <Form.Item
                              hasFeedback
                              required="true"
                              label="Alias Name">
                            <Input
                                name="aliasName"
                                size={"large"}
                                value={originator.aliasName ? originator.aliasName : ''}
                                onChange={event =>
                                    this.onOriginatorTextChange(event, ()=>{})
                                }
                            />
                          </Form.Item>
                        </Col>

                        <Col md={6}>
                          <Form.Item
                              hasFeedback
                              required="true"
                              label="Former Registered Name">
                            <Input
                                name="formerName"
                                size={"large"}
                                value={originator.formerName ? originator.formerName : ''}
                                onChange={event =>
                                    this.onOriginatorTextChange(event, ()=>{})
                                }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                )}

                {originator.originatorType === 'CORPORATE' && (
                    <div>
                      <Row gutter={16}>
                        <Col className="gutter-row" md={12} sm={6}> 
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.businessname"})}
                              required="true"
                              validateStatus={checkCorporateRequiredFieldsFilled.businessName ? "success" : "error"}
                              help={checkCorporateRequiredFieldsFilled.businessName ? '' : intl.formatMessage({id: "app.message.originatormodal.businessname"})}
                          >
                            <Input name="businessName"
                                   disabled={this.props.disabled}
                                   value={originator.businessName}
                                   onChange={this.onOriginatorTextChange}
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={12} sm={6}> 
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.incorporatedcountry"})}
                              required="true"
                              validateStatus={checkCorporateRequiredFieldsFilled.countryIncorporated ? "success" : "error"}
                              help={checkCorporateRequiredFieldsFilled.countryIncorporated ? '' : intl.formatMessage({id: "app.message.originatormodal.incorporatedcountry"})}
                          >
                            <BrdgxCountrySelector
                                disabled={this.props.disabled}
                                placeholder="Select Country"
                                size={"large"}
                                style={{width:'100%'}}
                                required="true"
                                value={originator.countryIncorporated ? originator.countryIncorporated : ''}
                                countries={this.state.countries}
                                onChange={newValue =>
                                    this.onOriginatorFieldChanged("countryIncorporated", newValue)
                                }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row gutter={16}>
                        <Col className="gutter-row" md={8} sm={6}>
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.businessnumber"})}
                              required="true"
                              validateStatus={checkCorporateRequiredFieldsFilled.businessNumber ? "success" : "error"}
                              help={checkCorporateRequiredFieldsFilled.businessNumber ? '' : intl.formatMessage({id: "app.message.originatormodal.businessnumber"})}
                          >
                            <Input name="businessNumber"
                                   disabled={this.props.disabled}
                                   value={originator.businessNumber}
                                   onChange={this.onOriginatorTextChange}
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={8} sm={6}>
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.dateofincorporation"})}
                              required="true"
                              validateStatus={checkCorporateRequiredFieldsFilled.dob ? "success" : "error"}
                              help={checkCorporateRequiredFieldsFilled.dob ? '' : intl.formatMessage({id: "app.message.originatormodal.dateofincorporation"})}
                          >
                            <DatePicker
                                size={"large"}
                                style={{ width: '100%' }}
                                defaultValue={null}
                                value={
                                  originator.dob
                                      ? moment(originator.dob, "YYYY-MM-DD")
                                      : null
                                }
                                placeholder="YYYY-MM-DD"
                                format={"YYYY-MM-DD"}
                                onChange={(newValue, newValueStr) =>
                                    this.onOriginatorFieldChanged("dob", newValueStr)
                                }
                            />
                          </Form.Item>
                        </Col>
                        <Col className="gutter-row" md={8} sm={6}>
                          <Form.Item
                              label={intl.formatMessage({id: "app.modal.originatormodal.businessnature"})}
                              required="true"
                              validateStatus={checkCorporateRequiredFieldsFilled.industry ? "success" : "error"}
                              help={checkCorporateRequiredFieldsFilled.industry ? '' : intl.formatMessage({id: "app.message.originatormodal.businessnature"})}
                          >
                            <IndustrySelector
                                disabled={this.props.disabled}
                                style={{width: '100%'}}
                                size={"large"}
                                industries={this.props.industries}
                                placeholder="Select Business Nature/Industry"
                                value={originator.industry}
                                onChange={this.changeBusinessNature}
                            />
                            {/*<Input name="businessNature"
                                   disabled={this.props.disabled}
                                   value={originator.businessNature}
                                   onChange={this.onOriginatorTextChange}
                            />*/}
                          </Form.Item>
                        </Col>
                      </Row>


                      <Row gutter={16}>
                        <Col md={6}>
                          <Form.Item
                              hasFeedback
                              required="true"
                              label="Alias Name">
                            <Input
                                name="aliasName"
                                size={"large"}
                                value={originator.aliasName ? originator.aliasName : ''}
                                onChange={event =>
                                    this.onOriginatorTextChange(event, ()=>{})
                                }
                            />
                          </Form.Item>
                        </Col>

                        <Col md={6}>
                          <Form.Item
                              hasFeedback
                              required="true"
                              label="Former Registered Name">
                            <Input
                                name="formerName"
                                size={"large"}
                                value={originator.formerName ? originator.formerName : ''}
                                onChange={event =>
                                    this.onOriginatorTextChange(event, ()=>{})
                                }
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                )}
              </div>
          )}
        </Modal>
    )
  }
}

export default withUseIntl(OriginatorModal);